// Basic structure
import React, { useContext, useEffect,useState } from "react";
import { Modal, Input, Row, Col,Select, Button, Radio } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import DirectoryContext from "../../../context/directoryManagementContext";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import { useQuery,useMutation, useQueryClient } from "react-query";
import { ToastContainer, toast } from "react-toastify";
import ErrorMessage from "../../Forms/ErrorMessage";
import "../../../Styles/user.css";
import Places from "../../../Pages/gms/Places";
import { useTranslation } from "react-i18next";

const AddPartyMember = ({ isOpen, isAddMode }) => {
  const directoryContext = useContext(DirectoryContext);
  const axiosInstance = useAxiosInstance();
  const [isOtherPosition, setIsOtherPosition] = useState(false);
  const queryClient = useQueryClient();
  const [locationData, setLocationData] = useState("");
  const [coordinates, setCoordinates] = useState({ lat: "", long: "" });
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user"));
  const formik = useFormik({
    // initialValues: {
    //   firstName: isAddMode ? "" : directoryContext.editData.firstName,
    //   lastName: isAddMode ? "" : directoryContext.editData.lastName,
    //   email: isAddMode ? "" : directoryContext.editData.email,
    //   phone: isAddMode ? "" : directoryContext.editData.phone
    // }

    initialValues: {
      firstName: isAddMode ? "" : directoryContext.editData?.firstName || "",
      lastName: isAddMode ? "" : directoryContext.editData?.lastName || "",
      position: isAddMode ? "" : directoryContext.editData?.position || "",
      phone: isAddMode ? "" : directoryContext.editData?.phone || "",
      email: isAddMode ? "" : directoryContext.editData?.email || "",
      place: isAddMode ? "" : directoryContext.editData?.place || "",
      // coordinates:isAddMode ? {lat:"",lng:""} : directoryContext.editData?.locationData?.address || {lat:"",lng:""},
      coordinates:isAddMode ? {lat:"",lng:""} : {
        lat: directoryContext.editData?.coordinates?.lat || "",
        lng: directoryContext.editData?.coordinates?.lng || ""
      },
      address: isAddMode ? "" : directoryContext.editData?.address || "",
      group: isAddMode ? "" : directoryContext.editData?.group || "",
      customPosition: isAddMode ? "" : directoryContext.editData?.customPosition || "",
      dob: isAddMode ? "" : directoryContext.editData?.dob?.split("T")[0] || "",
      isPriority:isAddMode ? false : directoryContext.editData?.isPriority || ""
    },

    enableReinitialize: true,
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string().required("Phone is required")
    }),
    // onSubmit: (values) => {
    //   if (isAddMode) {
    //     createMember.mutate(values);
    //   } else {
    //     updateMember.mutate(values);
    //   }
    // }

    onSubmit: (values) => {
      const payload = { ...values };
      if (values.position === "Other") {
        payload.position = values.customPosition;
      }
      // if(payload.place==="")
      // {
        payload.place=locationData.address;
      // }
      // if(payload.coordinates.lat==="" && payload.coordinates.lng==="")
      // {
        payload.coordinates.lat=locationData.lat;
        payload.coordinates.lng=locationData.lng;
      // }
      if (isAddMode) {
        // console.log("Data",payload)
        createMember.mutate(payload);
      } else {
        updateMember.mutate(payload);
      }
    }
  });
  // console.log("Location Data:",locationData)
  const createMember = useMutation(    
    (data) => axiosInstance.post("/api/directory/party-members", data),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("party-members");
        toast.success(res.data.message);
        closeModal();
      },
      onError: (err) => toast.error(err?.response?.data?.message || "Error")
    }
  );
  useEffect(() => {
    if (locationData?.address) {
      formik.setFieldValue("place", locationData.address);
    }
    if (locationData?.lat && locationData?.lng) {
      formik.setFieldValue("coordinates", {
        lat: locationData.lat,
        lng: locationData.lng
      });
    }
  }, [locationData]);
  // console.log("Logged in user",user?.role)
  const updateMember = useMutation(
    (data) =>
    axiosInstance.put(`api/directory/party-members/${directoryContext.editData._id}`, data).then((response) => response.data),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("party-members");
        toast.success(res.data.message);
        closeModal();
      },
      onError: (err) => toast.error(err?.response?.data?.message || "Error")
    }
  );

  const closeModal = () => {
    directoryContext.updateOpenModal(false);
    directoryContext.updateAddMode(true);
    formik.resetForm();
  };

    //fetch roles-->
    const fetchPositons = async () => {
      return axiosInstance.get("api/clients/getclientroles");
    };
    const { data: positionsData } = useQuery("positions", fetchPositons);


  return (
    <Modal 
      className='user-modal-wrapper  !w-[60%] top-[40px]'
      
      open={isOpen}
      onCancel={closeModal}
      title={isAddMode ? "Add New Contact" : "Edit Contact"}
      onOk={formik.handleSubmit}
      okText={isAddMode ? "Add" : "Save"}
      destroyOnClose
    >
      <form className=" " onSubmit={formik.handleSubmit}>
      <div className="p-6" style={{padding: "0rem 1.6rem 0rem 1.6rem"}}>
      <Row gutter={16}>
        <Col span={12}>
          <label>First Name</label>
          <Input name="firstName" style={{ marginTop: "10px", width: "100%", height: "45px" }} value={formik.values.firstName} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.firstName} message={formik.errors.firstName} />
        </Col>
        <Col span={12}>
          <label>Last Name</label>
          <Input style={{ marginTop: "10px", width: "100%", height: "45px" }} name="lastName" value={formik.values.lastName} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.lastName} message={formik.errors.lastName} />
        </Col>
      </Row>
      <Row gutter={16} className="mt-3">
        <Col className="" span={12}>
          <label>Position</label>
          <Select className="!h-[45px]"
            style={{ marginTop: "10px", width: "100%", height: "45px" }}
            name="position"
            value={formik.values.position}
            onChange={(value) => {
              if (value === "Other") {
                setIsOtherPosition(true);
                formik.setFieldValue("position", "Other");
                formik.setFieldValue("group", "common");
              } else {
                setIsOtherPosition(false);
                formik.setFieldValue("position", value);
                const normalized = value.toLowerCase();
                if (["client", "chief_of_staff"].includes(normalized)) {
                  formik.setFieldValue("group", "senior");
                } else if (["constituency_manager", "office_manager", "cadre"].includes(normalized)) {
                  formik.setFieldValue("group", "mid");
                } else {
                  formik.setFieldValue("group", "common");
                }
              }
            }}
            placeholder="Select Position"
          >
            {positionsData?.data?.data?.map((pos) => (
              <Select.Option key={pos._id} value={pos.name}>
                {pos.name}
              </Select.Option>
            ))}
            <Select.Option value="Other">Other</Select.Option>
          </Select>
          <ErrorMessage hasError={!!formik.errors.position} message={formik.errors.position} />
        </Col>

        {isOtherPosition && (
          <Col span={12}>
            <label>Custom Position</label>
            <Input
            style={{ marginTop: "10px", width: "100%" , height: "45px"}}
              name="customPosition"
              value={formik.values.customPosition}
              onChange={formik.handleChange}
              placeholder="Enter your position"
            />
            <ErrorMessage hasError={!!formik.errors.customPosition} message={formik.errors.customPosition} />
          </Col>
        )}

        <Col span={12}>
          <label>Phone Number</label>
          <Input style={{ marginTop: "10px", width: "100%", height: "45px" }} name="phone" value={formik.values.phone} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.phone} message={formik.errors.phone} />
        </Col>
      </Row>
      <Row gutter={16} className="mt-3">
        <Col span={12}>
          <label>Email</label>
          <Input style={{ marginTop: "10px", width: "100%", height: "45px" }} name="email" value={formik.values.email} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.email} message={formik.errors.email} />
        </Col>
        {/* <Col span={12}>
          <label>Location</label>
          <Input name="place" value={formik.values.place} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.place} message={formik.errors.place} />
        </Col> */}
        <Col span={12}>
          <label>Group</label>
          <Select
          style={{ marginTop: "10px", width: "100%", height: "45px" }}
            name="group"
            value={formik.values.group}
            disabled
            options={[
              { value: "senior", label: "Senior" },
              { value: "mid", label: "Mid" },
              { value: "common", label: "Common" }
            ]}
          />
          <ErrorMessage hasError={!!formik.errors.group} message={formik.errors.group} />
        </Col>
      </Row>
      <Row gutter={16} className="mt-3">
        <Col span={24}>
          <label>Address</label>
          <Input style={{ marginTop: "10px", width: "100%", height: "45px" }} name="address" value={formik.values.address} onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.address} message={formik.errors.address} />
        </Col>
      </Row>
      <Row gutter={16} className="mt-3">
        <Col span={10}>
          <label>Date of Birth</label>
          <Input style={{ marginTop: "10px", width: "100%", height: "45px" }} name="dob" value={formik.values.dob} type="date" onChange={formik.handleChange} />
          <ErrorMessage hasError={!!formik.errors.dob} message={formik.errors.dob} />
        </Col>
        {(user?.role==='client' || user?.role==='chief_of_staff') && formik.values.dob &&
          <Col span={8}>
            <label>Priority</label>
            <Radio.Group
              name="isPriority"
              value={formik.values.isPriority}
              onChange={(e) => formik.setFieldValue("isPriority", e.target.value)}
            >
              <Radio className="radio" value={true}>Yes</Radio>
              <Radio className="radio" value={false}>No</Radio>
            </Radio.Group>
            <ErrorMessage
              hasError={!!formik.errors.isPriority}
              message={formik.errors.isPriority}
            />
          </Col>
        }
      </Row>

      <Row className="mt-3 " gutter={16}>
        <Col span={12} className="mb-6 ">
            Location
            <span className='required-field'>*</span>
        </Col>
          <Places setLocationData={setLocationData} initialLocation={{
            lat: formik.values.coordinates.lat,
            lng: formik.values.coordinates.lng,
            address: formik.values.place
          }}/>
          {/* <Places setLocationData={(value) => {
        setLocationData(value);
        formik.setFieldValue("place", value);
        }} /> */}
      </Row>
      
        </div>

      
      </form>
    </Modal>
  );
};

export default AddPartyMember;
